import { ILayoutFilter } from '@base/@types/components/Layout/Filters'

export const AlertProcessFilter: ILayoutFilter[] = [
  {
    id: 'centerTypes',
    label: 'Tipo de Centro',
    filterId: 'centerTypes',
    type: 'select',
    isMulti: true
  },
  {
    id: 'lojasIds',
    label: 'Centro',
    filterId: 'centers',
    type: 'select',
    isMulti: true
  },

  {
    id: 'produtosIds',
    label: 'Produto',
    type: 'select-api-post',
    apiUrl: '/v1/Produto/Compras',
    isMulti: true
  },
  {
    id: 'fornecedoresIds',
    label: 'Fornecedor',
    filterId: 'providersForPurchase',
    type: 'select',
    isMulti: true
  },
  {
    id: 'pedidosIds',
    label: 'Pedido',
    filterId: 'purchases',
    type: 'select-api',
    apiUrl: '/v1/PedidoCompra',
    isMulti: true
  },
  {
    id: 'tiposProcessos',
    label: 'Tipo de Abastecimento',
    filterId: 'typeOfSupply',
    type: 'select',
    isMulti: true
  },
  {
    id: 'periodo',
    label: 'Data',
    type: 'date-input',
    isMulti: false
  },
  {
    id: 'usuariosIds',
    label: 'Usuario',
    filterId: 'users',
    type: 'select',
    isMulti: true
  }
]
